import { Link } from '@paypalcorp/pp-react'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { TOPIC_TREE_COMPLETE_DATA } from '../../utils/prop-type-shape'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

//Hooks
import { useHelper } from '../../hooks/useHelper'
import useTracking from '../../hooks/useTracking'

// styles
import './topic-tree.less'

// Topic Tree Component
function TopicTree({ breadCrumbPath, topicTreeData }) {
  const [selectedTopic, setSelectedTopic] = useState('')
  const { generateLinkWithCoBrand } = useHelper()
  const { trackActivity, trackClick } = useTracking()

  useEffect(() => {
    trackActivity({ name: componentNames.TOPIC_TREE, type: fptiTypes.SUCCESS })
  }, [])

  useEffect(() => {
    if (breadCrumbPath) {
      setSelectedTopic(breadCrumbPath.split('/')[0])
    }
  }, [breadCrumbPath])

  // on click topic tree item handler
  const onClickHandler = (e, topic) => {
    e.stopPropagation()

    // track topictree item on click
    trackClick({
      name: componentNames.TOPIC_TREE,
      type: fptiTypes.ON_CLICK,
      link: `topic-tree|${topic.topicId}|clicked`,
    })
  }

  const isTopicTreeExist = () =>
    Array.isArray(topicTreeData) && topicTreeData.length

  const renderTopicTree = () => {
    if (isTopicTreeExist()) {
      return topicTreeData.map((topic) => (
        <li
          className={classNames('topic-tree-item', {
            'topic-tree-item--active': topic.topicId === selectedTopic,
          })}
          onClick={(e) => onClickHandler(e, topic)}
          key={topic.topicId}
          data-testid="hc-topic-tree-item"
        >
          <Link
            secondary={topic.topicId !== selectedTopic}
            href={generateLinkWithCoBrand(`/smarthelp/topic/${topic.topicId}`)}
            key={`topic_${topic.topicId}`}
            className="topic-tree-item__link"
            data-testid="hc-topic-tree-item-link"
          >
            {topic.topicName}
          </Link>
        </li>
      ))
    }
    return <></>
  }

  return (
    <>
      <ul data-testid="hc-topic-tree-list">{renderTopicTree()}</ul>
    </>
  )
}

TopicTree.propTypes = TOPIC_TREE_COMPLETE_DATA

export default TopicTree
